import { nameFromCC, slugFromCC } from 'tf-post-parser';

export const getLocationDetails = location => {
  if (!location) return {};
  let locationTitle;
  const { countryCode, subdivision, city } = location;
  const country = countryCode !== null ? nameFromCC(countryCode) : undefined;
  const countryslug =
    countryCode !== null ? slugFromCC(countryCode) : undefined;
  const locationLink = `/destinations/${countryslug}${
    subdivision ? `/${subdivision}` : ''
  }${city ? `/${city}` : ''}`;
  const locationSubtitle = `${city ? `${city}, ` : ''}${
    subdivision ? `${subdivision}, ` : ''
  }${country}`;
  if (city) locationTitle = city;
  else if (subdivision) locationTitle = subdivision;
  else locationTitle = country;
  return {
    locationTitle,
    locationSubtitle,
    locationLink,
    country,
  };
};
